export default __webpack_public_path__ + "static/media/ipad_13.8e40b9fa.png";